import {Dispatch, FC, SetStateAction} from 'react'
import {ModalComponent} from '../../../Layout/Modal'
import {Header} from '../componente'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  message?: string
  file?: any
}

const ModalErrorList: FC<Props> = ({show, setShow, message, file}) => {
  const arrayMessage = message?.split('\n')
  const handleClose = () => {
    setShow(!show)
  }
  return (
    <ModalComponent type='Alert' variant={'error'} show={show} handleClose={handleClose}>
      <Header text={file?.name || ''} />
      <div>
        <ul className='mb-0'>
          {arrayMessage
            ?.filter((item) => item.trim() !== '') // Filtrar elementos vacíos
            .map((item, index) => (
              <li key={index}>{item}</li>
            ))}
        </ul>
      </div>
    </ModalComponent>
  )
}

export {ModalErrorList}
